import { PortfolioProductOverviewEntry } from '@mews-commander/data-access';
import { TaxRateStrategyCoProduct } from '@mews-commander/types';

export interface EnrichedTaxValues {
    name: string;
    localName: string;
    taxStrategy: TaxRateStrategyCoProduct;
    taxRateCode?: string | null;
    taxValue: number;
}

export const mapEntryWithEnrichedTaxes = (
    entry: PortfolioProductOverviewEntry,
    enrichedTaxData: EnrichedTaxValues[]
) => ({
    ...entry,
    pricing: {
        ...entry.pricing,
        value: {
            ...entry.pricing.value,
            taxValues: enrichedTaxData,
        },
    },
});
